import { useState } from "react";
import { Link } from "react-router-dom";
import { useRecoilValue } from "recoil";
import styled from "styled-components";
import { resultState } from "../../../Data/Recoil";
import { ResultData } from "../../../Data/ResultData";
import { Button } from "../../../ui/Credit/Button/Button";
import { Container } from "../../../ui/Credit/Container/Container";
import { Image } from "../../../ui/Credit/Image/Image";
import { Modal } from "../../../ui/Credit/Modal/Modal";

const Title = styled.h2`
  width: 328px;
  font-size: 24px;
  margin: 16px 0;
`;

const Text = styled.span`
  width: max-content;
  font-size: ${(props) => props.fs || 17}px;
  color: ${(props) => props.color || "#000"};
  font-weight: ${(props) => props.b || "normal"};
  position: relative;

  &.iText::before {
    content: "";
    width: 100%;
    height: 20px;
    background-color: mediumpurple;
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0.3;
  }
`;

const Box = styled.div`
  width: 100%;
  margin-top: 32px;
  padding: 32px 0;
  background-color: rgba(147, 112, 219, 0.3);
  display: flex;
  flex-direction: column;
  align-items: center;

  background-image: url("https://meamrxrtxnna6744001.cdn.ntruss.com/contents/resources/img/credit-check-list/5.png");
  background-repeat: no-repeat;
  background-position: center center;
`;

const Box2 = styled.div`
  width: 328px;
  padding: 10px 20px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 15px;
  margin: 32px 0;
`;

const BenefitBox = styled.div`
  width: 328px;
  padding: 10px 20px;
  background-color: #fff;
  box-shadow: 0px 4px 10px -4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-top: -30px;
  border-radius: 15px;
`;

const ButtonBox = styled.div`
  margin: 40px 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Result = () => {
  const [open, setOpen] = useState(false);
  const resultValue = useRecoilValue(resultState);
  const data = ResultData.find((elem) => elem.val == resultValue);

  const copyLink = () => {
    setOpen(true);
    navigator.clipboard.writeText("nbchance.learningfit.co.kr");
  };

  return (
    <>
      <Container className="App-result">
        <div className="App-layout">
          <Image width={90} src={`https://meamrxrtxnna6744001.cdn.ntruss.com/contents/resources/img/logo/learningfit-logo.png`} />
          <Title>국카찬스 조회결과</Title>
          <Box>
            {data.credit !== 0 ? (
              <>
                <Title>축하드립니다!</Title>
                <Image
                  width={328}
                  src={`https://meamrxrtxnna6744001.cdn.ntruss.com/contents/resources/img/credit-check-list/1.png`}
                />
              </>
            ) : (
              <>
                <Title>앗.. 나는 받을 돈이 없네</Title>
                <Image
                  width={328}
                  src={`https://meamrxrtxnna6744001.cdn.ntruss.com/contents/resources/img/credit-check-list/3.png`}
                />
              </>
            )}
            <Box2>
              {data.credit !== 0 ? (
                <>
                  <Text color={"#6c15a7"}>당신의 국비지원 한도는?</Text>
                  <Text fs={40} b={"bolder"} className="iText">
                    {data.credit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}원!
                  </Text>
                </>
              ) : (
                <>
                  <Text color={"mediumpurple"}>국카찬스 안되면</Text>
                  <div
                    onClick={() => (window.location.href = "https://www.learningfit.co.kr/main/page.jsp?pid=p.20221109_01_landing")}
                  >
                    <Text
                      fs={40}
                      color={"mediumpurple"}
                      b={"bolder"}
                      className="iText"
                    >
                      러닝핏 찬스
                    </Text>
                    <Text color={"mediumpurple"}>를 잡자!</Text>
                    <Image 
                      width={300}
                      src={`https://meamrxrtxnna6744001.cdn.ntruss.com/contents/resources/img/credit-check-list/4.png`}
                    />
                  </div>
                </>
              )}
            </Box2>
          </Box>
          {data.credit !== 0 ? (
            <BenefitBox>
              <Text fs={50}>+</Text>
              <Text fs={24}>추가 <Text color={"red"} fs={30} b={"bold"}>50만원</Text> 혜택</Text>
              <Image
                width={300}
                src={`https://meamrxrtxnna6744001.cdn.ntruss.com/contents/resources/img/credit-check-list/2.png`}
              />
              <Text>코딩 배우고 싶다면?</Text>
              <Button
                bg="red"
                color="#fff"
                width={300}
                onClick={() => (window.location.href = "https://learningfit.co.kr/inc/reservation_kcredit.jsp")}
              >
                지금 사용하기 &gt;
              </Button>
            </BenefitBox>
          ) : null}

          <ButtonBox>
            <Button
              bg="#6c15a7"
              color="#fff"
              width={328}
              onClick={() => copyLink()}
            >
              친구에게 소문내기
            </Button>
            <Link to={"/"}>
              <Button className="restart" width={328}>
                한도 다시보기
              </Button>
            </Link>
          </ButtonBox>
        </div>
      </Container>

      <Modal open={open} handleClose={() => setOpen(false)} />
    </>
  );
};

export default Result;
